export const BASE_URL="https://www.kusavinibalaga.org/api.php";